import React, { useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import './App.css'
import 'primeflex/primeflex.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import Form from './pages/Form/Form'
import { getData } from './service/api'
import { Payment } from './pages/Payment/Payment'
import { formatedPath } from './service/url'
import Page404 from './components/Page404/Page404'
import { Success } from './pages/Payment/Success'
import { IconsSvg } from './components/IconsSvg/IconsSvg'
import { renderToStaticMarkup } from "react-dom/server";
import { Error } from './pages/Payment/Error'
function App() {
    const [data, setData] = useState(null)
    const [is404, setIs404] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            requestData(formatedPath(true))
        }, 0)
    }, [])

    const isExclude = () => {
        const exclude = ['/not_found', '/payment', '/success', '/error']
        let result = false
        exclude.forEach((excludeItem) => {
            if (!result) result = formatedPath() === excludeItem
        })
        return result
    }

    const requestData = (url) => {
        if (!isExclude(url)) {
            getData(url)
                .then((res) => {
                    if (res?.data.length === 0) {
                        setIs404(true)
                    } else {
                        setIs404(false)
                        setData(res.data.data)
                        if (res.data?.data?.title) {
                            document.title = res.data?.data?.title
                        }

                        document.documentElement.style.setProperty('--main-color', res.data?.data?.color)
                    }
                })
                .catch((err) => {
                    if (err.response.status === 404) {
                        setIs404(true)
                    }
                })
        }
    }

    // console.log(data)

    const svgString = encodeURIComponent(renderToStaticMarkup(<IconsSvg name='footer' fill={data?.color} />));
    return (
        <>
            {is404 && <Page404 />}
            {!is404 && (
                <div className="App " style={{ backgroundImage: `url("data:image/svg+xml,${svgString}")` }}>
                    <Routes>
                        {/* <Route path="/ae/web" element={<Form data={data}  />} /> */}
                        <Route path="/payment" exact element={<Payment data={data} />} />

                        <Route path="/success" exact element={<Success />} />
                        <Route path="/error" exact element={<Error />} />
                        {/* <Route path="*" element={<div className="error-404">404</div>} /> */}
                        <Route path="/not_found" exact element={<Page404 />} />
                        {/* <Route path="*" exact element={<div className="error-404">404</div>} /> */}
                        <Route path="*" element={<Form data={data} />} />
                    </Routes>
                </div>
            )}
        </>
    )
}

export default App
